import { useRootStore } from "store";
import EmailSubmitForm from "views/login/components/EmailSubmitForm";


export default function ResetPassword() {

  const { isActivated, sendResetPassword } = useRootStore(
    (state) => state.resetPassword
  );

  const sendLink = (email:string) => {
    sendResetPassword(email);
  }

  return (
    <>
      {isActivated ? (
        <div className={"box"}>
          <h1>Återställ lösenord</h1>
          <hr className="header-border" />
          <p>
            En länk för att ändra ditt lösenord har skickats till din e-post.
            Vänligen följ länken för att välja ett lösenord och logga in på
            MittKontor.
            <br />
          </p>
          <p>Får du inget återställningsmail?</p>
          <ul>
            <li>Titta i skräpposten</li>
            <li>Lägg till noreply@ludvig.se som betrodd avsändare</li>
            <li>
              Fel e-postadress?{" "}
              <a href="/resetpassword">Använd en annan e-postadress</a>
            </li>
            <li>
              Kanske har du inte aktiverat ditt konto? Kontakta då din rådgivare
              via mail eller på tel: 0771-27 27 27.{" "}
            </li>
          </ul>
        </div>
      ) : (
        <div className={"box"}>
          <h1>Återställ lösenord</h1>
          <hr className="header-border" />
          <p>
            Ange din e-postadress i fältet så skickar vi en länk till din
            e-post.
          </p>
          <EmailSubmitForm triggerAction={sendLink} />
        </div>
      )}
    </>
  );
}
